import { useEffect } from "react";
import { useVertical } from "@/shared/contexts/VerticalContext";
import { go } from "@/shared/dashboard/shell/navigate";
import { defaultCourseLanding } from "@/shared/lib/defaultCourse";

export function ArchivedSimulationRedirect() {
  const { defaultCourseId, resolved } = useVertical();
  useEffect(() => {
    if (resolved)
      go(defaultCourseLanding("/dashboard", defaultCourseId) ?? "/exercises");
  }, [defaultCourseId, resolved]);
  return null;
}
